import { render } from "./index.vue?vue&type=template&id=313fc0d2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=313fc0d2&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=313fc0d2&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313fc0d2"]])

export default __exports__